import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '@/plugins/featureset'
import '@/plugins/lodash'
import '@/plugins/axios'
import '@/plugins/portal'
import '@/plugins/fortawesome'
import '@/plugins/v-calendar'
import '@/plugins/composition-api'
import '@/plugins/vuelidate'
import '@/plugins/sentry'
import '@/plugins/opentelemetry'
import { apolloProvider } from '@/plugins/apollo'
import '@/assets/css/normalize.css'
import '@/assets/sass/app.scss'

// Пока отключен за ненадобностью
// import './registerServiceWorker'

Vue.config.productionTip = false

function createInstance () {
  new Vue({
    router,
    store,
    apolloProvider,
    render: h => h(App)
  }).$mount('#app')
}

store.dispatch('user/autoLogin').finally(() => {
  createInstance()
})
